























































































import { Component, Mixins } from 'vue-property-decorator'
import DexieService from '@/services/dexie-service'
import SnackbarService from '@/services/snackbar-service'
import { Cow } from '@/interfaces/Cow'
import axios from 'axios'
import moment from 'moment'
import ApiService from '@/services/api-service'
import AuthService from '@/services/auth-service'
import UploadSummary from '@/components/upload-data/UploadSummary.vue'

@Component({
  components: {
    UploadSummary,
  },
})
export default class UploadView extends Mixins(
  DexieService,
  SnackbarService,
  ApiService,
  AuthService
) {
  csvFile = null
  fileContent: any = ''
  cowsToUpload: any = null
  showErrorsDialogIsOpen = false

  cowIdsAndNumbers: any = []

  errors: any = []

  offset = new Date().getTimezoneOffset()

  uploadSummary: any = []

  created() {
    this.$store.state.showAppbar = true
    this.$store.state.changeBack = '/home'
    this.$store.state.navbarText = 'Upload datos'
    this.getCowIdsAndNumbers()
  }

  headers = [
    { text: 'Numero', value: 'number' },
    { text: 'Finca', value: 'farm' },
    { text: 'Hierro', value: 'iron' },
    { text: 'Raca', value: 'race' },
    { text: 'Color', value: 'color' },
    { text: 'Fetcha de Prenez', value: 'pregnancyDate' },
    { text: 'Facha de Nacimiento', value: 'birthDate' },
    { text: 'Observation', value: 'observation' },
    { text: 'Fertilidad', value: 'fertility' },
    { text: 'Revisionado', value: 'selected' },
    { text: 'Numero de madre', value: 'mother_number' },
    { text: 'Vaca', value: 'female' },
    { text: 'Status', value: 'status' },
    { text: 'abortions', value: 'abortions' },
    { text: 'revisions', value: 'revisions' },
    { text: 'additional cols', value: 'additional_cols' },
  ]

  fileSelected() {
    if (!this.csvFile) {
      return
    }
    console.log(this.csvFile)
    const reader = new FileReader()
    reader.readAsText(this.csvFile)
    reader.onload = () => {
      this.fileContent = reader.result
      const cows: Cow[] = []
      this.errors = []
      const allNumbers = []
      this.fileContent.split(`\n`).forEach((line: string) => {
        const row = line.split(';')
        const number = row[0]
          .replace(/"/g, '')
          .replace(/=/g, '')
          .trim()
        allNumbers.push(number)
      })
      let firstAdditionalCols: any
      this.fileContent.split(`\n`).forEach((line: string, i: number) => {
        const error = { i, messages: [] }
        if (i === 0) {
          return
        }

        const row = line.split(';')
        console.log('row number', i)
        console.log('row length', row.length)
        if (row.length !== 16) {
          error.messages.push('The line does not have 15 semicolons')
          this.errors.push(error)
          return
        }
        const cow: any = {}
        const number = row[0]
          .replace(/"/g, '')
          .replace(/=/g, '')
          .trim()
        if (this.cowIdsAndNumbers.find((c: any) => c.text === number)) {
          error.messages.push(`Cow with number ${number} already exists`)
          this.errors.push(error)
          return
        }
        if (cows.map(c => c.number).includes(number)) {
          error.messages.push(`Cow with number ${number} already exists`)
          this.errors.push(error)
          return
        }
        cow.number = number
        cow.race = row[1].trim()
        cow.color = row[2].trim()
        cow.iron = row[3].trim()

        // pregnancyDate
        let pregnancyDate: any
        if (['null', ''].includes(row[4].trim())) {
          pregnancyDate = null
        } else {
          const date = moment(row[4].trim())
          if (!date.isValid()) {
            error.messages.push(
              `Can not convert pregnancy Date ${row[4].trim()} to date`
            )
            this.errors.push(error)
            return
          } else {
            pregnancyDate = row[4].trim()
          }
        }
        cow.pregnancyDate = pregnancyDate

        // birthDate
        let birthDate: any
        if (['null', ''].includes(row[5].trim())) {
          birthDate = null
        } else {
          const date = moment(row[5].trim())
          if (!date.isValid()) {
            error.messages.push(
              `Can not convert pregnancy Date ${row[5].trim()} to date`
            )
            this.errors.push(error)
            return
          } else {
            birthDate = row[5].trim()
          }
        }
        cow.birthDate = birthDate

        cow.observation = row[6].trim()
        cow.farm = row[7].trim()
        cow.fertility = row[8].trim()

        // selected
        let selected
        if (!['false', 'true'].includes(row[9].trim())) {
          error.messages.push(
            `Can not convert selected ${row[9].trim()} to boolean`
          )
          this.errors.push(error)
          return
        } else {
          selected = row[9] == 'false' ? false : true
        }
        cow.selected = selected

        // mother number
        let motherNumber
        if (['null', ''].includes(row[10].trim())) {
          motherNumber = null
        } else {
          if (
            !allNumbers.includes(row[10].trim()) &&
            !this.cowIdsAndNumbers.find((c: any) => c.text === row[10].trim())
          ) {
            error.messages.push(
              `Mother with number ${row[10].trim()} not found in csv file or data`
            )
            this.errors.push(error)
            return
          } else {
            motherNumber = row[10].trim()
          }
        }
        cow.mother_number = motherNumber

        // female
        cow.female = row[11]

        // status
        let status
        if (!['possession', 'sold', 'dead'].includes(row[12].trim())) {
          error.messages.push(
            `Status ${row[12].trim()} is not valid. Valid is only: possession, dead, sold`
          )
          this.errors.push(error)
          return
        } else {
          status = row[12].trim()
        }
        cow.status = status

        // additional cols
        const additionalCols = JSON.parse(row[13].trim())
        additionalCols.forEach((additionalCol: any) => {
          if (
            JSON.stringify(
              Object.keys(additionalCol).sort((v1, v2) => (v1 > v2 ? 1 : -1))
            ) !== JSON.stringify(['name', 'type', 'value'])
          ) {
            error.messages.push(`Missing keys in obejct.  ${row[13].trim()}`)
            this.errors.push(error)
          }
        })
        if (this.errors.map(e => e.i).includes(i)) {
          return
        }

        const typesAddCols = additionalCols
          .map((val: any) => val.type)
          .sort((t1, t2) => (t1 > t2 ? -1 : 1))

        if (
          typesAddCols.some(
            (type: string) => !['date', 'string', 'select'].includes(type)
          )
        ) {
          error.messages.push(
            `Unrecognised type. Allowed is only 'string', 'date' and 'select': ${row[13].trim()}`
          )
          this.errors.push(error)
          return
        }

        if (i === 1 || !firstAdditionalCols) {
          firstAdditionalCols = additionalCols
        } else if (i > 1) {
          if (firstAdditionalCols.length !== additionalCols.length) {
            error.messages.push(
              `Format of additional cols does not fit the format of the first row ${row[13].trim()}`
            )
            this.errors.push(error)
            return
          }
          const typesFirstAddCols = firstAdditionalCols
            .map((val: any) => val.type)
            .sort((t1, t2) => (t1 > t2 ? -1 : 1))
          if (
            JSON.stringify(typesAddCols) !== JSON.stringify(typesFirstAddCols)
          ) {
            error.messages.push(
              `Types of additional cols does not fit the format of the first row ${row[13].trim()}`
            )
            this.errors.push(error)
            return
          }
        }
        if (typesAddCols.includes('date')) {
          const dateCols = additionalCols.filter(v => v.type === 'date')
          dateCols.forEach((dateCol: any) => {
            let date = dateCol.date
            try {
              date = moment
                .utc(date)
                .zone(this.offset)
                .format('YYYY-MM-DD HH:mm')
            } catch {
              error.messages.push(`Could not read date: ${row[13].trim()}`)
              this.errors.push(error)
              return
            }
          })
        }
        cow.additional_cols = additionalCols

        // abortions
        cow.abortions = JSON.parse(row[14])

        // revisions
        cow.revisions = JSON.parse(row[15])

        if (error.messages.length === 0) {
          cows.push(cow)
        } else {
          this.errors.push(error)
        }
      })
      this.cowsToUpload = cows
    }
  }

  getCowIdsAndNumbers() {
    this.fetchCowIdsAndNumbers().then((cowIdsAndNumbers: any) => {
      this.cowIdsAndNumbers = cowIdsAndNumbers
      console.log(this.cowIdsAndNumbers)
    })
  }

  uploadCows() {
    this.$store.state.loading = true
    axios.post('add-csv', this.cowsToUpload).then((res: any) => {
      const uploadSummary = []
      Object.keys(res.data).forEach((sum: string) => {
        uploadSummary.push({
          name: this.mapName(sum),
          count: res.data[sum].length,
          list: res.data[sum],
        })
      })
      this.$store.state.uploadSummary = uploadSummary
      this.getAccount(this.$store.state.user.account_id).then((res: any) => {
        this.notify({
          text: `${this.cowsToUpload.length} cows uploaded successfully`,
          type: 'success',
          timeout: 10000,
        })
        this.cowsToUpload = null
        this.csvFile = null
        this.fileContent = ''
        this.errors = []
        this.$store.state.account = res.data
        this.$store.state.selectedFarmId = this.$store.state.account.farms[0].id
        this.$store.state.loading = false
      })
    })
  }

  mapName(name: string) {
    let nameVerbose
    switch (name) {
      case 'created_cows':
        nameVerbose = 'Created Cows'
        break
      case 'created_farms':
        nameVerbose = 'Created Farms'
        break
      case 'created_irons':
        nameVerbose = 'Created Irons'
        break
      case 'created_races':
        nameVerbose = 'Created Races'
        break
      default:
        nameVerbose = name
    }
    return nameVerbose
  }

  destroyed() {
    this.$store.state.uploadSummary = null
  }
}
